export default __webpack_public_path__ + "static/media/no_question_asked.5b4a14f3.svg";